import { Code, Server, Container, TestTube } from "lucide-react";
import { motion } from "framer-motion";

const Skills = () => {
  const skillCategories = [
    {
      category: "Frontend",
      icon: Code,
      skills: [
        { name: "React", level: 95 },
        { name: "Next.js", level: 90 },
        { name: "TypeScript", level: 90 },
        { name: "Zustand", level: 85 },
        { name: "SCSS", level: 88 },
      ],
    },
    {
      category: "Backend",
      icon: Server,
      skills: [
        { name: "Node.js", level: 92 },
        { name: "Express", level: 90 },
        { name: "PostgreSQL", level: 88 },
        { name: "Sequelize", level: 85 },
      ],
    },
    {
      category: "DevOps",
      icon: Container,
      skills: [
        { name: "Docker", level: 82 },
        { name: "GitHub Actions", level: 80 },
        { name: "NGINX", level: 78 },
        { name: "Firebase", level: 85 },
      ],
    },
    {
      category: "Testing",
      icon: TestTube,
      skills: [
        { name: "Jest", level: 88 },
        { name: "React Testing Library", level: 85 },
      ],
    },
  ];

  return (
    <section id="skills" className="py-24 bg-secondary/50">
      <div className="container mx-auto px-6">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-bold mb-12 text-center"
        >
          Skills & <span className="text-gradient">Expertise</span>
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {skillCategories.map((category, idx) => {
            const IconComponent = category.icon;
            return (
              <motion.div 
                key={idx} 
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                className="bg-card p-6 rounded-lg border border-border card-shadow hover:border-primary/50 transition-colors"
              >
                <h3 className="text-xl font-semibold mb-6 text-primary flex items-center gap-2">
                  <IconComponent className="w-5 h-5" />
                  {category.category}
                </h3>
                
                <div className="space-y-4">
                  {category.skills.map((skill, skillIdx) => (
                    <div key={skillIdx}>
                      <div className="flex justify-between mb-2">
                        <span className="text-sm font-mono">{skill.name}</span>
                        <span className="text-sm text-muted-foreground">{skill.level}%</span>
                      </div>
                      <div className="h-2 bg-secondary rounded-full overflow-hidden">
                        <motion.div
                          initial={{ width: 0 }}
                          whileInView={{ width: `${skill.level}%` }}
                          viewport={{ once: true }}
                          transition={{ duration: 1, delay: idx * 0.1 + skillIdx * 0.1, ease: "easeOut" }}
                          className="h-full bg-gradient-to-r from-primary to-accent"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
